goog.provide('el8.practicedata.base');

goog.require('el8.practicedata.recurringEventSchedules');
goog.require('el8.practicedata.appts');
goog.require('el8.practicedata.rxSigs');
goog.require('el8.practicedata.medOrderTemplates');

/**
 * Models with data owned by the practice live in this directory,
 * although since many models have practice-owned and global data,
 * the boundary between practicedata/ and data/ can be ambiguous.
 * We tend to bias toward adding models to data/, although models
 * linked specifically to practice home are often a good fit for
 * practicedata.
 */
el8.practicedata.load = function(arg) {
    var items = arg;

    // Support single item as argument
    if (!(arg instanceof Array)) { items = [arg]; }

    var results = [];
    for (var i=0; i<items.length; i++) {
        var entitySet = el8.practicedata.getEntitySet(items[i]['model_class']);
        results.push(entitySet.create(items[i], true)); // should NOT notify
    }
    return results;
};

el8.practicedata.getEntitySet = function(mClass) {
    switch(mClass) {
        case 'IncomingFileGroup':
            return el8.practicedata.incomingFileGroups;
        case 'UploadedImage':
            return el8.practicedata.uploadedImages;
        case 'UploadedFile':
            return el8.practicedata.uploadedFiles;
        case 'Appointment':
            return el8.practicedata.appts;
        case 'RecurringEventSchedule':
            return el8.practicedata.recurringEventSchedules;
        case 'LetterTemplate':
            return el8.practicedata.letterTemplates;
        case 'RxSig':
            return el8.practicedata.rxSigs;
        case 'MedOrderTemplate':
            return el8.practicedata.medOrderTemplates;
        default:
            return null;
    }
};

el8.practicedata.getUploadedFileOrImage = function(id, noFetch) {
    var local = el8.practicedata.uploadedImages.getById(id, true) ||
        el8.practicedata.uploadedFiles.getById(id, true);
    return noFetch ? local : 
        local || el8.practicedata.uploadedImages.getById(id) ||
            el8.practicedata.uploadedFiles.getById(id);
};


// unused?
el8.practicedata.fetch = function(arg, force, async) {

    var fetchArgs = arg;
    var returnSingle = false;

    // Support a single id as argument
    if (!(arg instanceof Array)) {
        returnSingle = true;
        fetchArgs = [arg];
    }

    var results = [];
    var needFetch = [];
    if (force === true) {
        needFetch = fetchArgs.map(function(a) { return a['id']; });
        // Set all elements of 'results' to null
        results = fetchArgs.map(function(a) {return null;});
    } else {
        fetchArgs.map(function(a) {
            var entitySet = el8.practicedata.getEntitySet(a['model_class']);
            var r = entitySet.getById(a['id']);
            if (!r) { r = entitySet.getDeletedById(a['id']); }
            results.push(r); 
            if (!r) { needFetch.push(a['id']); }
        });
    }
    // At this point, 'results' should be the same length as
    // 'ids' and contain only objects we want to return (null otherwise).
    // Meanwhile, 'needFetch' contains all the ids we need to fetch
    if (needFetch.length) { 
        $.el8_ajax({
            type: 'GET',
            url: '', // TODO
            async: (async === true), // defaults to false, i.e. sync call
            data: { id: needFetch },
            success: function(data) {
                // We assume the results come back in the same
                // order as we sent up the id's
                var fetched = data;
                if (fetched.length !== needFetch.length) {
                    el8.uiwidget.alert('Sorry, there was an error fetching one of '+
                        'the documents you requested');
                }
                for(var i=0; i<results.length; i++) {
                    if (!results[i]) {
                        var obj = fetched.shift();
                        var entitySet = el8.practicedata.getEntitySet(obj['model_class']);
                        results[i] = entitySet.create(obj, true); // should NOT notify
                    }
                }
            }
        });
    }
    return returnSingle ? results[0] : results;
};


